module.exports = __webpack_public_path__ + "static/media/Whatsapp.5c502654.svg";